module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("页面切换转场动画")]), _vm._v(" "), _c('p', [_vm._v("你可以注意到 demo 站点的切换动画，本质上是使用 "), _c('code', [_vm._v("Vue")]), _vm._v(" 的 "), _c('code', [_vm._v("transition")]), _vm._v(" 组件实现的。")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[ ] todo")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-74620b44", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-74620b44"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vue-router-page-transition-162.vue
// module id = 2333
// module chunks = 211